import { Link } from "react-router-dom";

export interface Crumb {
  name: string;
  href?: string;
}

export default function Breadcrumbs({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑导航" className="text-xs font-label text-foreground-500">
      <ol className="flex flex-wrap items-center gap-2">
        <li>
          <Link to="/" className="transition-colors hover:text-primary-700 cursor-pointer">
            首页
          </Link>
        </li>
        {items.map((item) => (
          <li key={item.name} className="flex items-center gap-2">
            <i className="ri-arrow-right-s-line text-foreground-400" aria-hidden="true"></i>
            {item.href ? (
              <Link to={item.href} className="transition-colors hover:text-primary-700 cursor-pointer">
                {item.name}
              </Link>
            ) : (
              <span className="text-foreground-800">{item.name}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}